module.exports = __webpack_public_path__ + "static/img/index_swiper1.9c34362.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index_swiper1.jpg
// module id = 1nAi
// module chunks = 1